import LogoPlus from '@assets/logo-plus.png';
import { PageTitle } from '@components/PageTitle';
import { useAuth } from '@contexts/auth';
import { cn } from '@lib/ui/cn';
import { Link } from 'react-router';

const emergency = [
  {
    id: 1,
    name: 'Drogas Vasoativas',
    sku: 'drogas_vasopressoras',
    isReleased: false,
  },
  {
    id: 2,
    name: 'Drogas Vasodilatadoras',
    sku: 'drogas_vasodilatadoras',
    isReleased: false,
  },
  {
    id: 3,
    name: 'Drogas IOT',
    sku: 'drogas_iot',
    isReleased: true,
  },
  {
    id: 4,
    name: 'Sedação Contínua',
    sku: 'drogas_sedacao',
    isReleased: true,
  },
  {
    id: 5,
    name: 'Distúrbios do Sódio',
    sku: 'correcao_sodio',
    isReleased: true,
  },
  {
    id: 6,
    name: 'Hidratação Queimado (Parkland)',
    sku: 'hidratacao_queimado',
    isReleased: false,
  },
];

const dayToDay = [
  {
    id: 1,
    name: 'Taxa filtração glomerular',
    sku: 'clearance',
    isReleased: true,
  },
  {
    id: 2,
    name: 'Ajuste de Dose para Função Renal',
    sku: 'correcao_dose',
    isReleased: false,
  },
  {
    id: 3,
    name: 'Conversão ml/h e gotas/min',
    sku: 'conversor_gota',
    isReleased: true,
  },
  {
    id: 4,
    name: 'Drogas anti-epiléticas: qual escolher?',
    sku: 'anti_epileticos',
    isReleased: false,
  },
  {
    id: 5,
    name: 'Conversor corticoide',
    sku: 'conversor_corticoide',
    isReleased: false,
  },
  {
    id: 6,
    name: 'Conversor opioide',
    sku: 'conversor_opioide',
    isReleased: false,
  },
];

const pediatrics = [
  {
    id: 1,
    name: 'Dose emergência pediatria',
    sku: 'dose_emergencia',
    isReleased: false,
  },
  {
    id: 2,
    name: 'Dose sintomáticos pediatria',
    sku: 'dose_sistomatico',
    isReleased: true,
  },
  {
    id: 3,
    name: 'Dose antibióticos pediatria',
    sku: 'dose_antibiotico',
    isReleased: false,
  },
  {
    id: 4,
    name: 'Hidratação pediatria (Holliday)',
    sku: 'hidratacao_pediatria',
    isReleased: false,
  },
];

function CalculatorList() {
  const { user } = useAuth();

  return (
    <div>
      <PageTitle hasBackButton title="Calculadoras" />
      <div>
        <h1 className="text-primary text-center text-lg font-semibold">
          Para usar na emergência ou no CTI
        </h1>
        <div className="mb-10 mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
          {emergency.map((item) => (
            <Link
              className={cn(
                'text-background shadow-foreground/50 hover:shadow-foreground/60 flex items-center justify-center gap-2 rounded-lg p-3 text-base font-bold shadow-md transition-all duration-300 hover:scale-[1.02] lg:p-5 lg:text-lg',
                item.isReleased && 'gradient-background',
                !item.isReleased && !user?.accessGranted
                  ? 'bg-border text-primary'
                  : 'gradient-background',
              )}
              key={item.id}
              to={
                !item.isReleased && !user?.accessGranted
                  ? '/pagamento'
                  : `/calculadoras/${item.sku}`
              }>
              {item.name}
              {!item.isReleased && !user?.accessGranted && (
                <div className="bg-primary rounded-md p-1">
                  <img alt="Logo plus" className="w-20" src={LogoPlus} />
                </div>
              )}
            </Link>
          ))}
        </div>

        <h1 className="text-primary text-center text-lg font-semibold">
          Para usar no dia a dia
        </h1>
        <div className="mb-10 mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
          {dayToDay.map((item) => (
            <Link
              className={cn(
                'text-background shadow-foreground/50 hover:shadow-foreground/60 flex items-center justify-center gap-2 rounded-lg p-3 text-base font-bold shadow-md transition-all duration-300 hover:scale-[1.02] lg:p-5 lg:text-lg',
                item.isReleased && 'gradient-background',
                !item.isReleased && !user?.accessGranted
                  ? 'bg-border text-primary'
                  : 'gradient-background',
              )}
              key={item.id}
              to={
                !item.isReleased && !user?.accessGranted
                  ? '/pagamento'
                  : `/calculadoras/${item.sku}`
              }>
              {item.name}
              {!item.isReleased && !user?.accessGranted && (
                <div className="bg-primary rounded-md p-1">
                  <img alt="Logo plus" className="w-20" src={LogoPlus} />
                </div>
              )}
            </Link>
          ))}
        </div>

        <h1 className="text-primary text-center text-lg font-semibold">
          Em pediatria
        </h1>
        <div className="mb-10 mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
          {pediatrics.map((item) => (
            <Link
              className={cn(
                'text-background shadow-foreground/50 hover:shadow-foreground/60 flex items-center justify-center gap-2 rounded-lg p-3 text-base font-bold shadow-md transition-all duration-300 hover:scale-[1.02] lg:p-5 lg:text-lg',
                item.isReleased && 'gradient-background',
                !item.isReleased && !user?.accessGranted
                  ? 'bg-border text-primary'
                  : 'gradient-background',
              )}
              key={item.id}
              to={
                !item.isReleased && !user?.accessGranted
                  ? '/pagamento'
                  : `/calculadoras/${item.sku}`
              }>
              {item.name}
              {!item.isReleased && !user?.accessGranted && (
                <div className="bg-primary rounded-md p-1">
                  <img alt="Logo plus" className="w-20" src={LogoPlus} />
                </div>
              )}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CalculatorList;
